import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import StoreContext from "../../components/Store/Context";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Button,
} from "@mui/material";

import {
  Content,
  Filter,
  FilterTitle,
  CloseFilter,
  Indicators,
  FulfillModal,
  FulfillModalTitle,
  CloseFulfillModal,
  FormBox,
  DownloadExcelWrapper,
  Overlay,
} from "../../utils/stylesbase";

import Sidebar from "../../components/Sidebar";
import {
  DeleteButton,
  EditButton,
  FulfillButton,
  Main,
  RemoveFulfillButton,
  SubTitle,
  Table,
  TableActions,
  Tables,
  Title,
} from "./deliverylist";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { API_URL } from "../../utils/env";

const convertDate = (date) => {
  if (!date) return "";

  date = date.split("/");
  const day = date[0];
  const month = date[1];
  const year = date[2];

  return new Date(`${year}-${month}-${day}`);
};

const convertDateBRtoEN = (date) => {
  if (!date) return "";

  date = date.split("/");
  const day = date[0];
  const month = date[1];
  const year = date[2];

  return `${year}-${month}-${day}`;
};

const DeliveryList = () => {
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);

  const [deliveries, setDeliveries] = useState([]);
  const [filteredDeliveries, setFilteredDeliveries] = useState([]);
  const [activeFilter, setActiveFilter] = useState(false);
  const [filtersOptions, setFiltersOptions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState(0);
  const [fulfillModalOpened, setFulfillModalOpened] = useState(false);
  const [recordsToFulfill, setRecordsToFulfill] = useState([]);
  const [selectedOrderRef, setSelectedOrderRef] = useState("");
  const [fulfillOption, setFulfillOption] = useState("add");
  const [selectedLines, setSelectedLines] = useState([]);

  const { sidebarClosed, userName, userPermissions, setSidebarClosed } =
    useContext(StoreContext);

  const tableRef = useRef(null);

  const [dateFilters, setDateFilters] = useState({
    registeredDateFormated: {
      start: "0001-01-02",
      end: "9999-12-08",
    },
  });

  const columnsNames = [
    {
      code: "orderRef",
      name: "#",
    },
    {
      code: "plataform",
      name: "Plataform",
    },
    {
      code: "name",
      name: "Name",
    },
    {
      code: "ticketsDate",
      name: "Tickets Date",
    },
    {
      code: "contact",
      name: "Contact",
    },
    {
      code: "country",
      name: "Country",
    },
    {
      code: "address",
      name: "Address",
    },
    {
      code: "routeMap",
      name: "Route Map",
    },
    {
      code: "deliveryDay",
      name: "Delivery Day",
    },
    {
      code: "preferredTime",
      name: "Preferred Time",
    },
    {
      code: "currency",
      name: "Currency",
    },
    {
      code: "price",
      name: "Price",
    },
    {
      code: "fulfilled",
      name: "Fulfilled",
    },
    {
      code: "fulfillDateFormated",
      name: "Fulfill Date",
    },
    {
      code: "dateOfRegistrationFormated",
      name: "Date of Registration",
    },
    {
      code: "comments",
      name: "Comments",
    },
    {
      code: "createdBy",
      name: "Created By",
    },
    {
      code: "lastEditBy",
      name: "Last Edit By",
    },
  ];

  const deleteDelivery = useCallback(
    (deliveryId, orderRef) => {
      if ([5].indexOf(userPermissions) !== -1) return;
      MySwal.fire({
        title: `Are you sure you want to delete the delivery on booking ${orderRef}?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          fetch(`${API_URL}deliveries/delete.php?id=${deliveryId}`, {
            method: "POST",
          })
            .then((response) => response.json())
            .then((response) =>
              Swal.fire("Delivery removed successfully!!", "", "success").then(
                () => {
                  return navigate(0);
                }
              )
            );
        }
      });
    },
    [userPermissions]
  );

  const editDelivery = useCallback((deliveryId) => {
    navigate(`/delivery-update?id=${deliveryId}`);
  }, []);

  const fulfillDelivery = useCallback(
    async (orderRef, option) => {
      if ([5].indexOf(userPermissions) !== -1) return;
      fetch(`${API_URL}fulfill/get-all.php?order-ref=${orderRef}`)
        .then((response) => response.json())
        .then((response) => {
          setFulfillOption(option);
          setRecordsToFulfill(response);
          setSelectedOrderRef(orderRef);
          setReset(Math.random());
          setFulfillModalOpened(true);
        });
    },
    [userName, userPermissions]
  );

  const openFilter = useCallback(
    (filter) => {
      setSearch("");
      setActiveFilter(filter);
      let options = [];
      deliveries.forEach((delivery) => {
        if (options.indexOf(delivery[filter]) === -1)
          options.push(delivery[filter]);
      });
      setFiltersOptions(options);
    },
    [deliveries, setActiveFilter]
  );

  const closeFilter = useCallback(() => {
    setActiveFilter(false);
  }, [setActiveFilter]);

  const searchFilters = useCallback(
    (e) => {
      const search = e.target.value;
      const filter = activeFilter;
      setSearch(search);
      let options = [];
      deliveries.forEach((delivery) => {
        if (options.indexOf(delivery[filter]) === -1)
          options.push(delivery[filter]);
      });
      options = options.filter((a) =>
        a ? a.toLowerCase().includes(search.toLowerCase()) : false
      );
      options = options.sort((a, b) => (a > b ? 1 : -1));
      setFiltersOptions(options);
    },
    [activeFilter, deliveries]
  );

  const changeFilter = useCallback(
    (e, attribute, option) => {
      let newFilters = selectedFilters;
      if (e.target.checked) {
        if (newFilters.find((item) => item.attributeName === attribute)) {
          newFilters
            .find((item) => item.attributeName === attribute)
            .selecteds.push(option);
        } else {
          newFilters.push({ attributeName: attribute, selecteds: [option] });
        }
      } else {
        newFilters
          .find((item) => item.attributeName === attribute)
          .selecteds.splice(
            newFilters
              .find((item) => item.attributeName === attribute)
              .selecteds.indexOf(option),
            1
          );
      }

      setSelectedFilters(newFilters);
      setReset(Math.random());
    },
    [selectedFilters, activeFilter]
  );

  const changeDateFilter = useCallback(
    (e, filter, id) => {
      let newDateFilters = dateFilters;
      newDateFilters[filter][id] = e.target.value;
      setDateFilters(newDateFilters);
      setReset(Math.random());
    },
    [dateFilters]
  );

  const checkFilterIsActive = useCallback(
    (option) => {
      if (
        selectedFilters.find((item) => item.attributeName === activeFilter) &&
        selectedFilters
          .find((item) => item.attributeName === activeFilter)
          .selecteds.indexOf(option) !== -1
      )
        return true;
      else return false;
    },
    [activeFilter, selectedFilters, reset]
  );

  const checkIfColumnIsFiltered = useCallback(
    (column) => {
      let filters = [];

      deliveries.forEach((delivery) => {
        if (filters.indexOf(delivery[column]) === -1)
          filters.push(delivery[column]);
      });

      const total = filters.length;

      if (
        !selectedFilters.find((filter) => filter.attributeName === column) ||
        !selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds
      )
        return false;

      return (
        selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds.length !== total
      );
    },
    [selectedFilters]
  );

  const selectAll = useCallback(() => {
    let newFilters = selectedFilters;

    let filter = newFilters.find(
      (filter) => filter.attributeName === activeFilter
    );

    deliveries.forEach((delivery) => {
      if (filter.selecteds.indexOf(delivery[activeFilter]) === -1)
        filter.selecteds.push(delivery[activeFilter]);
    });

    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = filter.selecteds;

    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const clearAll = useCallback(() => {
    let newFilters = selectedFilters;
    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = [];
    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const resetFilters = useCallback(() => {
    //Seleciona todos os filtros possíveis
    let filters = [];

    columnsNames.forEach((attribute) => {
      deliveries.forEach((ticket) => {
        if (filters.find((item) => item.attributeName === attribute.code)) {
          if (
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.indexOf(ticket[attribute.code]) === -1
          )
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.push(ticket[attribute.code]);
        } else {
          filters.push({
            attributeName: attribute.code,
            selecteds: [ticket[attribute.code]],
          });
        }
      });
    });
    setSelectedFilters(filters);
  }, [deliveries]);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const elements = Array.from(e.target.elements);
      let body = [];
      elements.forEach((el) => {
        if (el.tagName === "INPUT") {
          const type = el.id.split("-")[0].trim();
          const id = el.id.split("-")[1].trim();
          if (el.checked) {
            body.push({
              type,
              id,
            });
          }
        }
      });
      if (fulfillOption === "add") {
        fetch(`${API_URL}fulfill/fulfill-several.php`, {
          method: "POST",
          body: JSON.stringify({ records: body, lastEditBy: userName }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            } else {
              Swal.fire("Records fulfilled successfully!!", "", "success").then(
                () => {
                  return navigate(0);
                }
              );
            }
          });
      } else if (fulfillOption === "remove") {
        fetch(`${API_URL}fulfill/unfulfill-several.php`, {
          method: "POST",
          body: JSON.stringify({ records: body, lastEditBy: userName }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            } else {
              Swal.fire(
                "Records fulfill removed successfully!!",
                "",
                "success"
              ).then(() => {
                return navigate(0);
              });
            }
          });
      }
    },
    [fulfillOption]
  );

  const toggleSelectedLine = useCallback(
    (ticketId) => {
      let newSelectedLines = selectedLines;
      if (newSelectedLines.indexOf(ticketId) === -1)
        newSelectedLines.push(ticketId);
      else newSelectedLines.splice(newSelectedLines.indexOf(ticketId), 1);
      setSelectedLines(newSelectedLines);
      setReset(Math.random());
    },
    [selectedLines]
  );

  useEffect(() => {
    setSidebarClosed(true);
    fetch(`${API_URL}deliveries/list-all.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setDeliveries(response);
        setFilteredDeliveries(response);

        //Seleciona todos os filtros possíveis
        let filters = [];

        columnsNames.forEach((attribute) => {
          response.forEach((delivery) => {
            if (filters.find((item) => item.attributeName === attribute.code)) {
              if (
                filters
                  .find((item) => item.attributeName === attribute.code)
                  .selecteds.indexOf(delivery[attribute.code]) === -1
              )
                filters
                  .find((item) => item.attributeName === attribute.code)
                  .selecteds.push(delivery[attribute.code]);
            } else {
              filters.push({
                attributeName: attribute.code,
                selecteds: [delivery[attribute.code]],
              });
            }
          });
        });
        setSelectedFilters(filters);

        //Seta a maior e menor data de RegisteredDate
        let registeredDateStart = "";
        let registeredDateEnd = "";
        response.forEach((delivery) => {
          if (registeredDateStart === "") {
            registeredDateStart = delivery.registeredDateFormated;
            registeredDateEnd = delivery.registeredDateFormated;
          } else {
            if (
              convertDate(delivery.registeredDateFormated) <
              convertDate(registeredDateStart)
            )
              registeredDateStart = delivery.registeredDateFormated;
            if (
              convertDate(delivery.registeredDateFormated) >
              convertDate(registeredDateEnd)
            )
              registeredDateEnd = delivery.registeredDateFormated;
          }

          let dates = dateFilters;
          dates.registeredDateFormated.start =
            convertDateBRtoEN(registeredDateStart);
          dates.registeredDateFormated.end =
            convertDateBRtoEN(registeredDateEnd);
        });
      });
  }, []);

  //Atualiza os deliveries filtrados
  useEffect(() => {
    const filteredItems = deliveries.filter((delivery) => {
      let ok = true;
      selectedFilters.forEach((filter) => {
        if (filter.selecteds.indexOf(delivery[filter.attributeName]) === -1) {
          ok = false;
          return;
        }
      });
      if (
        convertDate(delivery.registeredDateFormated) <
          new Date(dateFilters.registeredDateFormated.start) ||
        convertDate(delivery.registeredDateFormated) >
          new Date(dateFilters.registeredDateFormated.end)
      ) {
        ok = false;
      }

      return ok;
    });
    setFilteredDeliveries(filteredItems);
  }, [selectedFilters, reset, deliveries, dateFilters]);

  useEffect(() => {
    let dollarTotal = 0;
    let realTotal = 0;
    filteredDeliveries.forEach((delivery) => {
      if (delivery.currency === "$")
        dollarTotal += parseFloat(delivery.price || 0);
      else if (delivery.currency === "R$")
        realTotal += parseFloat(delivery.price || 0);
    });
    setIndicators({
      dollarTotal: dollarTotal,
      realTotal: realTotal,
    });
  }, [filteredDeliveries]);

  return (
    <Main>
      <Sidebar />
      <Content sidebarclosed={sidebarClosed.toString()}>
        {[1, 2, 5].indexOf(userPermissions) !== -1 && (
          <Indicators>
            <thead>
              <tr>
                <th>$ Total</th>
                <th>R$ Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{indicators.dollarTotal}</td>
                <td>{indicators.realTotal}</td>
              </tr>
            </tbody>
          </Indicators>
        )}
        <SubTitle>Delivery</SubTitle>
        <Title>List</Title>
        <DownloadExcelWrapper>
          <DownloadTableExcel
            filename="Delivery-List"
            sheet="delivery-list"
            currentTableRef={tableRef.current}
          >
            <Button variant="outlined" style={{ marginBottom: "20px" }}>
              Export to excel
            </Button>
          </DownloadTableExcel>{" "}
          <Button
            variant="outlined"
            style={{ marginBottom: "20px", marginLeft: "20px" }}
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        </DownloadExcelWrapper>

        <Tables>
          <Table ref={tableRef}>
            <thead>
              <tr>
                {columnsNames.map((column) => {
                  return (
                    <th
                      onClick={() => openFilter(column.code)}
                      className={`${
                        checkIfColumnIsFiltered(column.code) ? "active" : ""
                      }`}
                      key={column.code}
                    >
                      {column.name}
                    </th>
                  );
                })}
                <th className="sticky-right"></th>
              </tr>
            </thead>
            <tbody>
              {filteredDeliveries.map((delivery) => {
                return (
                  <tr
                    key={delivery.id}
                    className={
                      selectedLines.indexOf(delivery.id) !== -1
                        ? "selected"
                        : delivery.fulfilled === "1"
                        ? "fulfilled"
                        : ""
                    }
                    onClick={() => toggleSelectedLine(delivery.id)}
                  >
                    <td>{delivery.orderRef}</td>
                    <td>{delivery.plataform}</td>
                    <td>{delivery.name}</td>
                    <td>{delivery.ticketsDate}</td>
                    <td>{delivery.contact}</td>
                    <td>{delivery.country}</td>
                    <td>{delivery.address}</td>
                    <td>{delivery.routeMap}</td>
                    <td>{delivery.deliveryDay}</td>
                    <td>{delivery.preferredTime}</td>
                    <td>{delivery.currency}</td>
                    <td>{delivery.price}</td>
                    <td>
                      {delivery.fulfilled === "1" ? (
                        <CheckBoxIcon />
                      ) : (
                        <CheckBoxOutlineBlankIcon />
                      )}
                    </td>
                    <td>{delivery.fulfillDateFormated}</td>
                    <td>{delivery.dateOfRegistrationFormated}</td>
                    <td>{delivery.comments}</td>
                    <td>{delivery.createdBy}</td>
                    <td>{delivery.lastEditBy}</td>
                    {[1, 4, 5].indexOf(userPermissions) !== -1 && (
                      <td className="sticky-right">
                        <Tooltip title="Edit" placement="top">
                          <EditButton
                            onClick={() => editDelivery(delivery.id)}
                          />
                        </Tooltip>
                        <Tooltip title="Delete" placement="top">
                          <DeleteButton
                            onClick={() =>
                              deleteDelivery(delivery.id, delivery.orderRef)
                            }
                          />
                        </Tooltip>
                        {delivery.fulfilled === "1" ? (
                          <Tooltip title="Remove Fulfill" placement="top">
                            <RemoveFulfillButton
                              onClick={() =>
                                fulfillDelivery(delivery.orderRef, "remove")
                              }
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Fulfill" placement="top">
                            <FulfillButton
                              onClick={() =>
                                fulfillDelivery(delivery.orderRef, "add")
                              }
                            />
                          </Tooltip>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Tables>
        <Filter opened={(activeFilter !== false).toString()}>
          <FilterTitle>
            Filtering{" "}
            {activeFilter &&
              columnsNames.find((filter) => activeFilter === filter.code).name}
          </FilterTitle>
          <CloseFilter onClick={() => closeFilter()} />
          {activeFilter === "registeredDateFormated" ? (
            <div className="date-filter">
              <TextField
                id={`start-${activeFilter}`}
                label="Start Date"
                variant="outlined"
                name={`start-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.start}
                onChange={(e) => changeDateFilter(e, activeFilter, "start")}
              />
              <TextField
                id={`end-${activeFilter}`}
                label="End Date"
                variant="outlined"
                name={`end-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.end}
                onChange={(e) => changeDateFilter(e, activeFilter, "end")}
              />
            </div>
          ) : (
            <ul status={reset}>
              <div className="filters-actions">
                <span onClick={selectAll}>Select All</span>
                <span onClick={clearAll}>Clear All</span>
              </div>
              <div className="filters-search">
                <TextField
                  id="search"
                  label="Search"
                  variant="outlined"
                  name="search-delivery"
                  value={search}
                  onChange={searchFilters}
                />
              </div>
              <div class="filters-options">
                {filtersOptions.map((option) => {
                  return (
                    <li key={option}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={option}
                              name={option}
                              onChange={(e) =>
                                changeFilter(e, activeFilter, option)
                              }
                              checked={checkFilterIsActive(option)}
                            />
                          }
                          label={
                            activeFilter === "fulfilled"
                              ? option === "1"
                                ? "Yes"
                                : "No"
                              : option
                          }
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </div>
            </ul>
          )}
        </Filter>
        <Overlay opened={fulfillModalOpened.toString()}>
          <FulfillModal status={reset} opened={fulfillModalOpened.toString()}>
            <FulfillModalTitle>
              Select records to{" "}
              {fulfillOption === "add" ? "fulfill" : "remove fulfill"} on
              order-ref {selectedOrderRef}
            </FulfillModalTitle>
            <CloseFulfillModal onClick={() => setFulfillModalOpened(false)} />
            <FormBox
              component="form"
              noValidate
              autoComplete="off"
              onSubmit={onSubmit}
            >
              {recordsToFulfill.map((record) => (
                <FormGroup key={`${record.id}-${record.type}`}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={`${record.type} - ${record.id}`}
                        name={record.id}
                        record-type={record.type}
                        inputProps={{
                          "record-type": record.type,
                        }}
                      />
                    }
                    label={`${record.type} ${
                      record.date ? `- ${record.date}` : ""
                    } ${record.sector ? `- ${record.sector}` : ""}`}
                  />
                </FormGroup>
              ))}
              <Button variant="outlined" type="submit">
                Save
              </Button>
            </FormBox>
          </FulfillModal>
        </Overlay>
      </Content>
    </Main>
  );
};

export default DeliveryList;
